import { render } from "./MarketingPixelsIntegrationSettings.vue?vue&type=template&id=f1b20fb4"
import script from "./MarketingPixelsIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./MarketingPixelsIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__